import React, {Suspense} from 'react';
import logo from './logo.svg';
import './App.css';
import Header from "./components/Header";
import HeaderAndroid from "./components/HeaderAndroid";
import Sidebar from "./components/Sidebar";
import Footer from "./components/Footer";
import {BrowserRouter as Router, Routes, Route, Link, useParams} from 'react-router-dom';
import {useLocation} from "react-router";
import CompetitionsEvent from './pages/events/CompetitionsEvent';
import Competitions from './pages/science/Competitions';

const NewsPattern = React.lazy(() => import("./pages/NewsPattern"));
const OurEvents = React.lazy(() => import("./pages/events/OurEvents"));
const Main = React.lazy(() => import("./pages/Main"));
const History = React.lazy(() => import("./pages/main/History"));
const Administration = React.lazy(() => import("./pages/main/Administration"));
const Partneram = React.lazy(() => import("./pages/main/Partneram"));
const Teachers = React.lazy(() => import("./pages/main/Teachers"));
const News = React.lazy(() => import("./pages/News"));
const HSK = React.lazy(() => import("./pages/HSK"));
const Gallery = React.lazy(() => import("./pages/Gallery"));
const ChineseCourses = React.lazy(() => import("./pages/studies/ChineseCourses"));
const Price = React.lazy(() => import("./pages/studies/Price"));
const Schedule = React.lazy(() => import("./pages/studies/Schedule"));
const SummerCamp = React.lazy(() => import("./pages/studies/SummerCamp"));
const ForumsAndConferences = React.lazy(() => import("./pages/science/ForumsAndConferences"));
const InternationalCompetition = React.lazy(() => import("./pages/science/InternationalCompetition"));
const DoctoralProgram = React.lazy(() => import("./pages/scholarship/DoctoralProgram"));
const HowApplyforTeacherScholarship = React.lazy(() => import("./pages/scholarship/HowApplyforTeacherScholarship"));
const ChineseGovScholarship = React.lazy(() => import("./pages/scholarship/ChineseGovScholarship"));
const LanguageScholarship = React.lazy(() => import("./pages/scholarship/LanguageScholarship"));
const MastersProgram = React.lazy(() => import("./pages/scholarship/MastersProgram"));
const PostgraduateSVU = React.lazy(() => import("./pages/scholarship/PostgraduateSVU"));
const SVUScholarship = React.lazy(() => import("./pages/scholarship/SVUScholarship"));
const UndergraduateProgram = React.lazy(() => import("./pages/scholarship/UndergraduateProgram"));

interface Props {

}

function Gett(): React.JSX.Element {
    const {newsId} = useParams(); // Get the parameter from the URL
    if (newsId !== undefined) {
        return <NewsPattern NewsID={newsId}/>;
    } else {
        return <></>;
    }
}

export default class App extends React.Component<Props, any> {
    render() {
        return <>
            <Router>
                <Header/>
                <HeaderAndroid/>
                <Sidebar/>
                <Suspense fallback={<Loading/>}>
                    <Routes>
                        <Route path="/" index element={<Main/>}/>
                        <Route path="news/:newsId" element={<Gett/>}/>
                        <Route path="main/">
                            <Route path={"history"} element={<History/>}/>
                            <Route path={"administration"} element={<Administration/>}/>
                            <Route path={"Partneram"} element={<Partneram/>}/>
                            <Route path={"Teachers"} element={<Teachers/>}/>
                        </Route>
                        <Route path={"studies/"}>
                            <Route path={"chinese-courses"} element={<ChineseCourses/>}/>
                            <Route path={"price"} element={<Price/>}/>
                            <Route path={"schedule"} element={<Schedule/>}/>
                            <Route path={"summer-camp"} element={<SummerCamp/>}/>
                        </Route>
                        <Route path={"science/"}>
                            <Route path={"competitions"} element={<Competitions/>}/>
                            <Route path={"forums-and-conferences"} element={<ForumsAndConferences/>}/>
                            <Route path={"international-competition"} element={<InternationalCompetition/>}/>
                        </Route>
                        <Route path={"events/"}>
                            <Route path={"our-events"} element={<OurEvents/>}/>
                            <Route path={"competitions"} element={<CompetitionsEvent/>}/>
                        </Route>
                        <Route path={"scholarship/"}>
                            <Route path={"chinese-gov-scholarship"} element={<ChineseGovScholarship/>}/>
                            <Route path={"doctoral-program"} element={<DoctoralProgram/>}/>
                            <Route path={"how-apply-for-teacher-scholarship"}
                                   element={<HowApplyforTeacherScholarship/>}/>
                            <Route path={"language-scholarship"} element={<LanguageScholarship/>}/>
                            <Route path={"masters-program"} element={<MastersProgram/>}/>
                            <Route path={"postgraduate-svu"} element={<PostgraduateSVU/>}/>
                            <Route path={"svu-gov-scholarship"} element={<SVUScholarship/>}/>
                            <Route path={"svu-scholarship"} element={<SVUScholarship/>}/>
                            <Route path={"undergraduate-program"} element={<UndergraduateProgram/>}/>
                        </Route>
                        <Route path={"news"} element={<News/>}/>
                        <Route path={"HSK"} element={<HSK/>}/>
                        <Route path={"gallery"} element={<Gallery/>}/>
                        <Route path="*" element={<NoMatch/>}/>
                    </Routes>
                </Suspense>
                <Footer/>
            </Router>
        </>
    }
};

function NoMatch() {
    return (
        <div className={`container`}>
            <p className="fs-2">Nothing to see here!</p>
            <p>
                <Link to="/">Go to the home page</Link>
            </p>
        </div>
    );
}

export function InProgress() {
    return (
        <div className={`container`}>
            <p className="fs-2">Страница в разработке</p>
            <p>
                <Link to="/">Go to the home page</Link>
            </p>
        </div>
    );
}

export function Loading() {
    return (
        <div className="spinner-grow" role="status">
            <span className="visually-hidden">Loading...</span>
        </div>
    );
}
